import React from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@/components/common/TextInput';
import { getStringOrEmpty } from '@/utils/helper';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  handleMarketingInfo: (field: string, value: string) => void;
};

export default function MarketingInformationFormGroup({
  album,
  readonly,
  disabled,
  showValidationErrors,
  fieldHasErrors,
  fieldValidationState,
  findErrorMessage,
  handleMarketingInfo,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={t('product.editProduct.marketingInfo')}
        handleInput={(e) => {
          handleMarketingInfo('marketingInformation', e.target.value);
        }}
        id="marketingInformation"
        type="text"
        value={getStringOrEmpty(
          album.albumMetaData?.marketing?.marketingInformation
        )}
        inputClassname="form-control"
        className="col-sm-6"
        isDisabled={disabled}
        isReadOnly={readonly}
        hasErrors={fieldHasErrors('MarketingInformation')}
        validationState={fieldValidationState?.('MarketingInformation')}
        errorMessage={findErrorMessage('MarketingInformation')}
        showValidationErrors={showValidationErrors}
        fieldValidationKey={'productEditMode.MarketingInformation'}
        component="textarea"
        rows={4}
      />
    </div>
  );
}
